var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcMailBox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 24H0V0H24V24Z",
    stroke: "#E5E7EB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 3C1.00781 3 0 4.00781 0 5.25C0 5.95781 0.332813 6.62344 0.9 7.05L11.1 14.7C11.6344 15.0984 12.3656 15.0984 12.9 14.7L23.1 7.05C23.6672 6.62344 24 5.95781 24 5.25C24 4.00781 22.9922 3 21.75 3H2.25ZM0 8.25V18C0 19.6547 1.34531 21 3 21H21C22.6547 21 24 19.6547 24 18V8.25L13.8 15.9C12.7312 16.7016 11.2688 16.7016 10.2 15.9L0 8.25Z",
    fill: "#092E5E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMailBox);
export default __webpack_public_path__ + "static/media/ic_mail_box.702ebe8f911aed16852c1bd46ad6326a.svg";
export { ForwardRef as ReactComponent };